var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-radius":"0.3rem"},attrs:{"id":"container2"}},[_c('h5',[_c('v-icon',{staticClass:"ma-2",attrs:{"color":"black","size":"15","right":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" Details ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }